import React, { useState } from "react";
import Header from "../../../components/Header";
import { booking } from "../../../common/svg";
import { bookingStatus } from "../../../common/staticData";
import { BookingViewTabs } from "../../../common/tabs";
import CustomChip from "../../../components/Chip";
import AdminCointainer from "../../../containers/Admin";
import Cointainer from "../../../containers/Admin/cointainer";
import CountCard from "../../../components/CounterCard";
import DaysLeftCounter from "../../../components/DaysProgress";
import CustomTabs from "../../../components/Tab";
import Trip from "../../Client/view/Trip";
import Vehicles from "../../Trip/view/Vehicles";
import { useParams } from "react-router-dom";
import CargoPage from "../../Trip/view/Cargo";
import Documents from "../../Trip/view/Documents";
import Expenses from "../../Trip/view/Expenses";
import Routes from "./RoutesDetails";
const BookingView = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState<string>("Trip Details");

  const handleTabChange = (tab: string) => {
    if (tab) {
      setActiveTab(tab);
    }
  };
  return (
    <div>
      <Header
        title="Booking"
        icon={booking}
        subtitleId="#JALKSOW22"
        contact="26 Aug 2025, 12:04 am"
        status={<CustomChip text="Ongoing" />}
      ></Header>

      <AdminCointainer className="!pt-[120px]">
        <Cointainer>
          <div className=" flex flex-row">
            <div className="flex justify-around !w-full p-4">
              {bookingStatus.map((status, index) => (
                <CountCard
                  key={index}
                  count={status.count}
                  label={status.lable}
                  backgroundColor={status.backgroundColor}
                  textColor={status.textColor}
                  className="w-[16%] gap-3 !text-[14px]"
                />
              ))}
            </div>
            <div className="flex items-center flex-col w-[200px] justify-center">
              <div className="flex items-center flex-row   justify-center">
                <DaysLeftCounter totalDays={5} />
                <p className="text-[14px] font-[400]">Total Trip</p>
              </div>
              <p className="text-[14px] font-[400]">30 July 2025, 10:00am </p>
            </div>
          </div>
        </Cointainer>
        <br />
        <CustomTabs
          tabs={BookingViewTabs}
          initialActiveTab="Trip Details"
          onTabChange={handleTabChange}
        />
        {
          activeTab === "Trip Details" && <Trip />
        }
        {
          activeTab === "Routes" && <Routes id={id} />
        }
        {
          activeTab === "Vehicles" && <Vehicles id={id}/>
        }
        {activeTab === "Cargo" && <CargoPage />}
          {activeTab === "Documents" && <Documents />}
          {activeTab === "Expenses" && <Expenses images={[]} />}
      </AdminCointainer>
    </div>
  );
};

export default BookingView;
